module.exports = __webpack_public_path__ + "static/media/logo_200.51bb8225.png";